import {
  Directive,
  effect,
  HostListener,
  inject,
  Input,
  type OnChanges,
  type SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { UAParser } from 'ua-parser-js';

type ConsiderViewWidthType = '' | 'considerViewWidth';

@Directive({
  selector: '[appShowOnMobileOrTablet]',
  standalone: true,
})
export class ShowOnMobileOrTabletDirective implements OnChanges {
  readonly #templateRef = inject(TemplateRef);
  readonly #viewContainer = inject(ViewContainerRef);
  @Input('appShowOnMobileOrTablet') considerViewWidth: ConsiderViewWidthType = '';

  constructor() {
    effect(() => {
      this.updateView();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appHasAccess'] !== undefined && changes['appHasAccess'].firstChange === false) {
      this.updateView();
    }
  }

  @HostListener('window:resize', [])
  onResize(): void {
    this.updateView();
  }

  private updateView(): void {
    const { device } = UAParser(window.navigator.userAgent);
    const deviceTypeIsMobileOrTablet =
      device.type !== undefined
        ? device.is('mobile') || device.is('tablet')
        : this.#fallbackDeviceTypeDetect() !== 'desktop';

    if (deviceTypeIsMobileOrTablet || this.considerViewWidth === 'considerViewWidth') {
      if (this.#viewContainer.length === 0) {
        this.#viewContainer.createEmbeddedView(this.#templateRef);
      }
    } else {
      this.#viewContainer.clear();
    }
  }

  #fallbackDeviceTypeDetect(): 'mobile' | 'tablet' | 'desktop' {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches;

    if (hasCoarsePointer) {
      if (isMobile) {
        return 'mobile';
      }
      return 'tablet';
    }

    return 'desktop';
  }
}
